import { UrlParamsKeys } from '@config/keys/url-params.keys';

const LOCALE_SEGMENT = /^[a-z]{2}(?:-[a-z]{2})?$/i;

/**
 * Preview must stay on the iframe URL the dashboard opened.
 * A navigation that drops `cbPreview` or changes the page reloads the webapp
 * in normal mode, which then resolves the marketplace from shared
 * `localStorage` (`marketplace_domain`) instead of the studio stub.
 */
export function isCb2PreviewNavigationAllowed(bootHref: string, targetUrl: string): boolean {
  const boot = parsePreviewUrl(bootHref, 'http://localhost');
  if (!boot) {
    return false;
  }
  const target = parsePreviewUrl(targetUrl, boot.href);
  if (!target || !target.searchParams.has(UrlParamsKeys.CbPreview)) {
    return false;
  }
  return previewPathname(target.pathname) === previewPathname(boot.pathname);
}

/** Full document loads (`location.href`, `location.assign`) always leave preview. */
export function assignBrowserLocation(
  url: string,
  isPreview: boolean,
  assign: (nextUrl: string) => void = nextUrl => window.location.assign(nextUrl),
): void {
  if (isPreview) {
    return;
  }
  assign(url);
}

function parsePreviewUrl(value: string, base: string): URL | null {
  try {
    return new URL(value, base);
  } catch {
    return null;
  }
}

function previewPathname(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean).map(decodePathSegment);
  if (parts[0] && LOCALE_SEGMENT.test(parts[0])) {
    parts.shift();
  }
  return parts.join('/');
}

function decodePathSegment(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
